import { ForwardedRef, forwardRef } from 'react';

import { Button, ButtonProps } from './Button';
import { cn } from 'styles';

export const IconButton = forwardRef(
  (
    { variant = 'ghost', round = true, className, ...props }: ButtonProps,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    return (
      <Button
        ref={ref}
        format="square"
        variant={variant}
        round={round}
        className={cn('text-current', className)}
        draggable={false}
        {...(props as ButtonProps)}
      />
    );
  },
);

IconButton.displayName = 'IconButton';
